module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_6.e054092a.png";